
import { AppService } from "app/services/app.service";
export abstract class AbUsuarioConta extends AppService {
  abstract enviarEmailConfirmarExlusao();
}